
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.219 6.781A2.57 2.57 0 0 0 19.334 6H17l-.53-1.417c-.133-.34-.374-.633-.725-.88-.35-.246-.71-.37-1.078-.37H9.333c-.368 0-.727.124-1.078.37-.35.247-.592.54-.724.88L7 6H4.667a2.57 2.57 0 0 0-1.886.781A2.57 2.57 0 0 0 2 8.667V18c0 .736.26 1.365.781 1.886.521.52 1.15.78 1.886.78h14.666a2.57 2.57 0 0 0 1.886-.78c.52-.521.781-1.15.781-1.886V8.667c0-.737-.26-1.365-.781-1.886Zm-5.922 9.85C14.384 17.543 13.285 18 12 18c-1.285 0-2.384-.457-3.297-1.37-.913-.914-1.37-2.013-1.37-3.297 0-1.285.457-2.384 1.37-3.297.913-.914 2.012-1.37 3.297-1.37 1.285 0 2.384.457 3.297 1.37.913.913 1.37 2.012 1.37 3.297 0 1.284-.457 2.383-1.37 3.296Z"}}),_c('path',{attrs:{"d":"M12 10.333a2.89 2.89 0 0 0-2.12.88 2.89 2.89 0 0 0-.88 2.12c0 .827.293 1.534.88 2.12a2.89 2.89 0 0 0 2.12.88 2.89 2.89 0 0 0 2.12-.88 2.89 2.89 0 0 0 .88-2.12 2.89 2.89 0 0 0-.88-2.12 2.89 2.89 0 0 0-2.12-.88Z"}})])
          )
        }
      }
    